class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      this.closest('cart-items').updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status');

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      }
    ];
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });


    fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{ body }})
      .then((response) => {
        return response.text().then((text) => {
          return text;
        });
      })
      .then((state) => {
        let parsedState;
        try {
          parsedState = JSON.parse(state);
        } catch (e) {
          console.error('Error parsing JSON:', e);
          throw new Error('Invalid JSON response');
        }
        if (!parsedState.sections) {
          console.error('parsedState.sections is null or undefined');
          throw new Error('Invalid response structure');
        }

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section => {
          const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        }));
        this.updateLiveRegions(line, parsedState.item_count);
        const lineItem =  document.getElementById(`CartItem-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) lineItem.querySelector(`[name="${name}"]`).focus();
        var lineProductId = null;
        if (document.querySelector('#CartItem-' + line)) {
          lineProductId = parseInt(document.querySelector('#CartItem-' + line).dataset.idth);
        }
        addAddOnItem(false, lineProductId, quantity);
        showHideExpressCheckoutButtons();
        updateRemainingNotice();
        //this.updateGiftNotice();
        this.disableLoading();
      }).catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        document.getElementById('cart-errors').textContent = window.cartStrings.error;
        this.disableLoading();
        window.location.reload();
      });
  }

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      document.getElementById(`Line-item-error-${line}`)
        .querySelector('.cart-item__error-text')
        .innerHTML = window.cartStrings.quantityError.replace(
          '[quantity]',
          document.getElementById(`Quantity-${line}`).value
        );
    }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  updateGiftNotice() {
    let progressBarElement = document.querySelector('.gift-progress__bar');
    let remainingGiftElement = document.querySelector('.remaining-gift');
    let remainingValueElement = document.querySelector('#remaining-gift-value');
    let subtotalElement = document.querySelector('.totals__subtotal-value');
    let subtotalValue = convertPriceToFloat(subtotalElement.innerHTML);
    let giftTreshold = parseInt(remainingGiftElement.dataset.gifttreshold);
    let showTreshold = parseInt(remainingGiftElement.dataset.showtreshold);
    let remaining = giftTreshold - subtotalValue;
    let progressBarProgress = 0;
    if (remaining > 0) {
      if (subtotalValue >= showTreshold) {
        remainingGiftElement.classList.remove('remaining-gift--free');
        remainingGiftElement.classList.remove('remaining-gift--hide');
        remainingGiftElement.classList.add('remaining-gift--remaining');
      } else {
        remainingGiftElement.classList.remove('remaining-gift--free');
        remainingGiftElement.classList.remove('remaining-gift--remaining');
        remainingGiftElement.classList.add('remaining-gift--hide');
      }
      progressBarProgress = subtotalValue * 100.0 / giftTreshold;
    } else {
      remainingGiftElement.classList.remove('remaining-gift--remaining');
      remainingGiftElement.classList.add('remaining-gift--free');
      progressBarProgress = 100;
    }
    var currency = document.body.dataset.currency == 'EUR' ? '€' : document.body.dataset.currency;
    remainingValueElement.innerHTML = parseFloat(remaining / 100) + ' ' + currency;
    progressBarElement.style.setProperty("--progressbar-width", progressBarProgress + "%");
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    document.getElementById('main-cart-items').classList.add('cart__items--disabled');
    this.querySelectorAll(`#CartItem-${line} .loading-overlay`).forEach((overlay) => overlay.classList.remove('hidden'));
    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    document.getElementById('main-cart-items').classList.remove('cart__items--disabled');
  }
}

customElements.define('cart-items', CartItems);
